export default "__VITE_ASSET__8jqddhJe__"